<template>
  <footer>
    <b-container>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <h4>CHRONEXT GmbH</h4>
              <p>
                Butzweilerhofallee 4 • 50829 Cologne • Germany<br />
                VAT ID: DE 451441052<br /><br />
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <h5>Buy Watches</h5>
              <ul class="contact-list">
                <li class="contact-item">
                  <div class="contact-item__number"><a href="tel:+491733626040">+49 151 51224113</a></div>
                  <div class="contact-item__name">(Ivry Schils via Whatsapp)</div>
                </li>
                <li class="contact-item">
                  <div class="contact-item__email">
                    <a href="mailto:b2b@chronext.com">b2b@chronext.com</a>
                  </div>
                </li>
              </ul>
            </b-col>
            <b-col cols="12" md="6">
              <h5>Sell Watches</h5>
              <ul class="contact-list">
                <li class="contact-item">
                  <div class="contact-item__number"><a href="tel:+491726960602">+49 172 6960602</a></div>
                  <div class="contact-item__name">(Vanessa Stratakis)</div>
                </li>
                <li class="contact-item">
                  <div class="contact-item__email">
                    <a href="mailto:newsourcing@chronext.com">newsourcing@chronext.com</a>
                  </div>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'cxt-Footer',
};
</script>

<style lang="scss" scoped>
footer {
  color: #cccccc;
  margin-top: 30px;
  padding: 30px;
  background-color: #0f0f0f;
  @media all and (max-device-width: 576px) {
    padding: 1em 0;
  }
}

.contact-list {
  margin: 0 0 2em;
  padding: 0;
  list-style-type: none;
}

.contact-item {
  display: block;
  &__number,
  &__name,
  &__email {
    float: left;
    @media all and (max-device-width: 576px) {
      font-size: 0.8rem;
    }
  }

  &.contact-item-top-margin {
    margin-top: 0.7em;
  }

  &__number {
    &::before {
      content: 'Tel: ';
    }
  }
  &__name {
    padding-left: 0.5em;
  }
  &__email {
  }
  &::after {
    content: '';
    clear: both;
    display: table;
  }
}
</style>
